export const GET_VENDOR_MEMBERS_REQUEST = "get_vendor_members_request";
export const GET_VENDOR_MEMBERS_SUCCESS = "get_vendor_members_success";
export const GET_VENDOR_MEMBERS_FAILURE = "get_vendor_members_failure";
